export const defaultBTFormValues = {
  creditLimitRequest: {
    creditLimitOptions: null,
    newCreditLimit: '',
  },
  balanceTransfer: {
    requestBalanceTransfer: null,
    balanceTransferList: {
      bt0: {
        amount: '',
        institutionName: '',
        billerCode: '',
        billerRef: '',
      },
    },
    tncConsent: false,
    confirmationConsent: false,
  },
};

export const institutions = [
  {
    id: '85621',
    name: 'AMP Bank',
  },
  {
    id: '6007',
    name: 'ANZ',
  },
  {
    id: '22863',
    name: 'Bank of Melbourne',
  },
  {
    id: '91215',
    name: 'Bank of Queensland',
  },
  {
    id: '9100',
    name: 'BankWest',
  },
  {
    id: '1818',
    name: 'Commonwealth Bank of Australia (CBA)',
  },
  {
    id: '17095',
    name: 'HSBC CARDS',
  },
  {
    id: '1008',
    name: 'NAB',
  },
  {
    id: '9779',
    name: 'St George Bank',
  },
  {
    id: '999532',
    name: 'Suncorp Bank',
  },
  {
    id: '5181',
    name: 'Westpac',
  },
  {
    id: '9787',
    name: 'Bank SA',
  },
  {
    id: '342949',
    name: 'Bendigo Bank',
  },
  {
    id: '238261',
    name: 'Beyond Bank Australia',
  },
  {
    id: '118760',
    name: 'Community First',
  },
  {
    id: '948521',
    name: 'Firefighters Mutual Bank',
  },
  {
    id: '74617',
    name: 'Heritage Bank',
  },
  {
    id: '464347',
    name: 'ME Bank',
  },
  {
    id: '948505',
    name: 'Teachers Mutual Bank',
  },
  {
    id: '948513',
    name: 'Unibank',
  },
  {
    id: '266650',
    name: 'Kogan Money',
  },
  {
    id: '253765',
    name: 'Myer Credit Card',
  },
  {
    id: '266536',
    name: 'Qantas Credit Card',
  },
  {
    id: '49551',
    name: 'Virgin Money',
  },
  {
    id: '17574',
    name: 'Woolworths Credit Card',
  },
];

export const defaultFormValues = {
  overview: {
    promoCode: '',
    consentGiven: false,
    applicationReason: '',
    conditionalStop: '',
  },
  contactDetails: {
    mobileNumber: '',
    emailAddress: '',
    confirmEmail: '',
  },
  verification: {
    verificationCode: '',
  },
  emailVerification: {
    verificationCode: '',
  },
  password: {
    password: '',
  },
  biometricsAboutYou: {
    title: '',
    relationshipStatus: '',
    numberOfDependents: '',
  },
  biometricsAddressDetails: {
    residentialStatus: '',
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
    previousAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
    postalAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
    hasNonDomesticPreviousAddress: false,
    isPostalSameWithResidential: '',
    lengthOfCurrentResidency: {
      years: '',
      months: '',
    },
    updateCurrentAddress: '',
    changeAddress: false,
  },
  personalDetails: {
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: {
      day: '',
      month: '',
      year: '',
    },
    hasAuDL: 'yes',
    hasMiddleName: 'no',
    australianState: '',
    driverLicenceNumber: '',
    driverLicenceCardNumber: '',
    relationshipStatus: '',
    numberOfDependents: '',
    crbConsent: false,
    dvsConsent: false,
    hasNzDriverLicence: '',
    idType: '',
    licenceNumber: '',
    version: '',
    idNumber: '',
    expiryDate: {
      day: '',
      month: '',
      year: '',
    },
    nzResidencyNumber: '',
    issuingCountry: '',
  },
  otherDetails: {
    residentialStatus: '',
    lengthOfCurrentResidency: {
      years: '',
      months: '',
    },
    isPostalSameWithResidential: '',
    hasNonDomesticPreviousAddress: false,
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
    previousAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
    postalAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
  },
  extraDetails: {
    idType: '',
    medicareCardName: '',
    individualReferenceNumber: '',
    medicareCardNumber: '',
    licenceNumber: '',
    version: '',
    idNumber: '',
    expiryDate: {
      day: '',
      month: '',
      year: '',
    },
    australianState: '',
    auPassportNumber: '',
    issuingCountry: '',
    name: '',
    dvsConsent: false,
    medicareCardColour: '',
    expiryDateGreen: {
      day: '',
      month: '',
      year: '',
    },
    expiryDateNonGreen: {
      day: '',
      month: '',
      year: '',
    },
    nameOnPassport: '',
    visaStartDate: {
      day: '',
      month: '',
      year: '',
    },
    visaEndDate: {
      day: '',
      month: '',
      year: '',
    },
    relationshipStatus: '',
    numberOfDependents: '',
    nzResidencyNumber: '',
  },
  expensesDetails: {
    isExpensesShared: '',
    isSummaryExpenses: '',
    mortgageRentBoard: {
      amount: '',
      frequency: '',
    },
    foodGroceriesLifestyleEntertainment: {
      amount: '',
      frequency: '',
    },
    insurance: {
      amount: '',
      frequency: '',
    },
    utilities: {
      amount: '',
      frequency: '',
    },
    educationAndChildcare: {
      amount: '',
      frequency: '',
    },
    transport: {
      amount: '',
      frequency: '',
    },
    personalAndOtherExpense: {
      amount: '',
      frequency: '',
    },
    basicExpenses: {
      amount: '',
      frequency: '',
    },
    additionalExpenses: {
      amount: '',
      frequency: '',
    },
    isRevolvingOrOffsetMortgage: '',
    facilityLimit: '',
    primaryPropertyMortgageRentBoard: {
      amount: '',
      frequency: '',
    },
    propertyUtilitiesOther: {
      amount: '',
      frequency: '',
    },
    generalInsurance: {
      amount: '',
      frequency: '',
    },
    educationChildcare: {
      amount: '',
      frequency: '',
    },
    personalFitnessMedical: {
      amount: '',
      frequency: '',
    },
    other: {
      amount: '',
      frequency: '',
    },
  },
  employmentDetails: {
    industry: '',
    incomeSource: '',
    employerName: '',
    lengthOfTimeAtCurrentEmployer: {
      years: '',
      months: '',
    },
    lengthOfUnemployment: {
      years: '',
      months: '',
    },
    income: {
      amount: '',
      frequency: '',
    },
    employmentStatus: '',
    hasOtherIncome: '',
    otherEmploymentStatus: '',
    otherIncome: {
      amount: '',
      frequency: '',
    },
    occupation: '',
    incomeAdjustmentRequired: '',
    conditionalStop: '',
  },
  additionalDebtsDetails: {
    hasOtherDebts: '',
    secondaryPropertyMortgageRentBoard: {
      amount: '',
      frequency: 'monthly',
    },
    totalCardLimits: '',
    amountOwingOnCreditCard: '',
    loanRepayment: {
      amount: '',
      frequency: 'monthly',
    },
    hasLoanLumpSumPayment: '',
    payLumpSumWithExistingSaving: '',
  },
  confirmCreditLimit: {
    newCreditLimit: '',
    creditLimitOptions: null,
  },
  confirmReferredCreditLimit: {
    newCreditLimit: '',
  },
  acceptance: {
    accepted: false,
  },
  achDetails: {
    hasAch: null,
    sameCurrentAddress: 'yes',
    personalDetails: {
      hasMiddleName: 'no',
      title: '',
      firstName: '',
      lastName: '',
      middleName: '',
      dateOfBirth: {
        day: '',
        month: '',
        year: '',
      },
      mobileNumber: '',
      emailAddress: '',
    },
    currentAddress: {
      useManualAddress: false,
      address: {
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        poBoxNumber: '',
        addressType: '',
        countryCode: '',
        state: '',
        city: '',
      },
    },
  },
  creditLimitAcceptance: {
    creditLimit: '',
    accepted: false,
  },
  biometricsIdentification: {
    idType: '',
    licenceNumber: '',
    version: '',
    idNumber: '',
    expiryDate: {
      day: '',
      month: '',
      year: '',
    },
    nzResidencyNumber: '',
    issuingCountry: '',
  },
  creditLimitDetails: {
    creditLimitSource: '',
    creditLimit: '',
  },
  ...defaultBTFormValues,
};
